import $ from "jquery";
// let description = null;
export const MapHelper = () => {
  let description = $(".description");
  let shiftPositionObject = {
    "IN-GA": {
      x: 1,
      y: 30
    },
    "IN-MN": {
      x: -5,
      y: 30
    },
    "IN-NL": {
      x: -5,
      y: 30
    },
    "IN-AS": {
      x: -5,
      y: 18
    },
    "IN-ML": {
      x: 1,
      y: 25
    },
    "IN-MZ": {
      x: 1,
      y: 25
    },
    "IN-TR": {
      x: 1,
      y: 30
    },
    "IN-SK": {
      x: 1,
      y: 30
    },
    "IN-AR": {
      x: -5,
      y: 20
    },
    "IN-WB": {
      x: 1,
      y: -25
    },
    "IN-BR": {
      x: 1,
      y: 10
    },
    "IN-JH": {
      x: 8,
      y: 10
    },
    "IN-AP": {
      x: 20,
      y: -20
    },
    "IN-KL": {
      x: 1,
      y: 10
    },
    "IN-KA": {
      x: 1,
      y: -25
    },
    "IN-MH": {
      x: 15,
      y: 5
    },
    "IN-MP": {
      x: 5,
      y: -15
    },
    "IN-HR": {
      x: 1,
      y: 15
    },
    "IN-UT": {
      x: 1,
      y: 15
    },
    "IN-PB": {
      x: 1,
      y: 10
    },
    "IN-HP": {
      x: 1,
      y: 15
    },
    "IN-JK": {
      x: 36,
      y: 8
    },
    "IN-Ladakh": {
      x: -34,
      y: -11
    },
    "IN-UP": {
      x: 5,
      y: -5
    },
    "IN-TG": {
      x: 5,
      y: 10
    },
    "IN-DL": {
      x: 1,
      y: 32
    },
    "IN-LD": {
      x: 8,
      y: 30
    },
    "IN-AN": {
      x: 50,
      y: 10
    }
  };

  // $(".enabled").hover(
  //   function() {
  //     // stopAutoAnim();
  //     description.addClass("active");
  //     description.html($(this).attr("title"));
  //   },
  //   function() {
  //     let listOfPaths = $(".enabled");
  //     listOfPaths.map(function(currentPath) {
  //       if ($(listOfPaths[currentPath]).hasClass("selected")) {
  //         description.html($(this).attr("title"));
  //         mouseEneter(listOfPaths[currentPath]);
  //       }
  //       return null;
  //     });
  //   }
  // );

  // $(".enabled").click(clickedAnimation);
  $(".enabled").on("mouseenter", clickedAnimation);

  // $('.india-map').on('mouseenter', function (e) {
  //   stopAutoAnim();
  // });
  // $('.india-map-details').on('mouseenter', function (e) {
  //   stopAutoAnim();
  // });
  // $(".enabled").on("mouseover", function(e) {
  //   mouseEneter(e);
  // });

  // $('.india-map').on('mouseleave', function (e) {
  //     var _autoAnim = setTimeout(function () {
  //         clearTimeout(_autoAnim);
  //         startAutoAnim();
  //     }, 0);
  // });

  // var autoStart = null;
  // var index = 0;

  // function stopAutoAnim() {
  //     autoStart && clearInterval(autoStart);
  // }

  // function startAnimOnInit(){
  //   stopAutoAnim();
  //   var listOfStates = ['IN-MP'];
  //   var listOfPaths = $('.enabled');
  //   listOfPaths.map(function (currentPath) {
  //       if ($(listOfPaths[currentPath]).attr('id') === listOfStates[index]) {
  //           $(listOfPaths[currentPath]).trigger('click');
  //           description.addClass('active');
  //           description.html($(this).attr('title'));
  //           mouseEneter(listOfPaths[currentPath]);
  //       }
  //   })
  //   index++;
  //   if (index >= listOfStates.length) {
  //       index = 0;
  //   }
  // }
  // startAnimOnInit();
  // function startAutoAnim() {
  //     stopAutoAnim();
  //     autoStart = setInterval(function () {
  //         var listOfStates = ['IN-JK', 'IN-UP', 'IN-MP', 'IN-WB', 'IN-BR'];
  //         var listOfPaths = $('.enabled');
  //         listOfPaths.map(function (currentPath) {
  //             if ($(listOfPaths[currentPath]).attr('id') === listOfStates[index]) {
  //                 $(listOfPaths[currentPath]).trigger('click');
  //                 description.addClass('active');
  //                 description.html($(this).attr('title'));
  //                 mouseEneter(listOfPaths[currentPath]);
  //             }
  //         })
  //         index++;
  //         if (index >= listOfStates.length) {
  //             index = 0;
  //         }
  //         initialized = true
  //     }, 3000);
  // }

  //startAutoAnim();

  function clickedAnimation(e) {
    $(".IN-LD")
      .find(".enabled")
      .prev()
      .removeClass("makeVisible");
    $(".IN-LD")
      .find(".enabled")
      .removeClass("selected");
    $(this).addClass("selected");
    $(this)
      .prev()
      .addClass("makeVisible");
    $(this)
      .parent()
      .siblings()
      .find(".enabled")
      .prev()
      .removeClass("makeVisible");
    $(this)
      .parent()
      .siblings()
      .find(".enabled")
      .removeClass("selected");
    var enabled = $(this).find(".enabled");

    //$(this).addClass("active").html($(this).attr("title"));
    //console.log("$(this)$(this)$(this)", $(this).attr('title'))
    mouseEneter(e);
    // var name = $(this).attr('title');
    // var id = $(this).data('tid');
    // if(map[id]) {
    //   $('.state-name').html(map[id]);
    // }else {
    //   $.ajax({
    //     type: "GET",
    //     url: '/get-state-html/' + id,
    //     success: function(data){
    //       $('.state-name').html(data.data);
    //       map[id] = data.data;
    //     }
    //   });
    // }

    if ($(this).attr("id") !== "IN-LD") {
      $(this)
        .parent()
        .appendTo("#map-parent");
    }
  }

  function mouseEneter(e) {
    var id =
      (e.hasOwnProperty("currentTarget") && e.currentTarget.id) ||
      $(e).attr("id");
    var idElem = document.getElementById(id);
    if (!idElem) {
      return null;
    }
    var clientReact = idElem.getBoundingClientRect();
    var description = document.querySelector(".description");
    var descPosition = description.getBoundingClientRect();
    var isSmallState = shiftPositionObject[id] || 0;
    // $(description).css({
    //     right: clientReact.x + clientReact.width / 2 - descPosition.width / 2 - ((isSmallState && isSmallState.x) || isSmallState),
    //     top: document.documentElement.scrollTop + clientReact.y - ((isSmallState && isSmallState.y) || isSmallState)
    // });
    var mapContainer = document.getElementsByClassName("india-map")[0];
    var mapContainerRect = mapContainer.getBoundingClientRect();
    $(description)
      .css({
        left:
          clientReact.left -
          mapContainerRect.left +
          clientReact.width / 2 -
          descPosition.width / 2 -
          ((isSmallState && isSmallState.x) || isSmallState),
        top:
          clientReact.top -
          mapContainerRect.top -
          ((isSmallState && isSmallState.y) || isSmallState)
      })
      .addClass("active")
      .html($(idElem).attr("title"));
  }

  function makeActive() {
    let listOfPaths = $(".enabled");
    listOfPaths.map(function(currentPath) {
      if ($(listOfPaths[currentPath]).hasClass("selected")) {
        description.html($(this).attr("title"));
        mouseEneter(listOfPaths[currentPath]);
      }
      return null;
    });
  }
  makeActive();
};
